/*
 * @Date: 2023-10-11 15:17:44
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-12-10 14:52:00
 * @FilePath: /nicee-web-tw/src/components/VoiceRoom/mRtc.js
 * @Description: web语音房声网
 * 加入房間
 * 获取麦克风权限
 * 創建本地軌道對象
 * 訂閲發佈-監聽取消發佈
 * 獲取列表-訂閲列表
 */
import i18n from '@/locales/index'
import Vue from 'vue';
import AgoraRTC from 'agora-rtc-sdk-ng';
import { MessageBox } from 'element-ui';
import VoiceRoomEventEmitter from '@/components/VoiceRoom/voiceRoomEventBus';
import VoiceRoomEvent from '@/components/VoiceRoom/voiceRoomEvent';
import util from '@/utils/util';
AgoraRTC.onAutoplayFailed = () => {
  MessageBox.confirm(i18n.t('components_voiceroom_mrtc_1924'));
};
const mRtc = Vue.observable({
  join: () => {},
  leave: () => {},
  initTrack: () => {},
  closeMic: () => {},
  openMic: () => {},
  enterSeat: () => {},
  leaveSeat: () => {},
  getMicrophones: () => {},
  subscribeRemoteUser: () => {},
  viewRemote: () => {},
  ready: () => {},
  publish: () => {},
  enableAudioVolumeIndicator: () => {},
  client: undefined,
  localAudioTrack: null,
  remoteUsers: {},
  isReady: false,
  isEnterSeat: false,
  isOpenMic: false,
  roomUid: undefined
});
/**
 * @description:加入房间
 * @param {appId, channel, token, uid} option
 * @return {*}
 */
mRtc.join = async option => {
  try {
    const { appId, channel, token, uid } = option;
    mRtc.roomUid = channel;
    const res = await mRtc.client.join(appId, channel, token, uid);
    mRtc.isJoin = true;
    console.log('加入声网成功', res);
    return res;
  } catch (error) {
    util.captureException(
      'voice-room',
      { roomUid: mRtc.roomUid, fun: 'mRtc.join' },
      error
    );
    throw error;
  }
};

/**
 * @description: 离开房间
 * @return {*}
 */
mRtc.leave = async () => {
  if (mRtc.localAudioTrack) {
    mRtc.localAudioTrack.close();
    // return await mRtc.client.leave();
  }
  await mRtc.client.leave();
};

/**
 * @description: 创建本地轨道对象
 * @return {*}
 */
mRtc.initTrack = async () => {
  const isUseSoundCard =
    localStorage.getItem(VoiceRoomEvent.isUseSoundCard) === 'true'
      ? true
      : false;
  try {
    const microphoneId = await mRtc.getMicrophones();
    if (microphoneId) {
      console.log('microphoneId', microphoneId);
    }
    mRtc.localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack({
      encoderConfig: 'high_quality_stereo',
      AEC: !isUseSoundCard,
      AGC: !isUseSoundCard,
      ANS: !isUseSoundCard
    });
    return mRtc.localAudioTrack;
  } catch (error) {
    util.captureException(
      'voice-room',
      { roomUid: mRtc.roomUid, fun: 'mRtc.initTrack' },
      error
    );
    throw error;
  }
};

/**
 * @description: 发布
 * @return {*}
 */
mRtc.publish = async () => {
  if (mRtc.isReady) {
    await mRtc.client.setClientRole('host');
    await mRtc.openMic();
    await mRtc.client.publish(mRtc.localAudioTrack);
    await mRtc.closeMic();
  } else {
    mRtc.publish();
  }
};

/**
 * @description: 闭麦
 * @return {*}
 */
mRtc.closeMic = async () => {
  try {
    await mRtc.localAudioTrack.setEnabled(false);
    mRtc.isOpenMic = false;
    return true;
  } catch (error) {
    util.captureException(
      'voice-room',
      { roomUid: mRtc.roomUid, fun: 'mRtc.closeMic' },
      error
    );
    throw error;
  }
};
/**
 * @description: 开麦
 * @return {*}
 */
mRtc.openMic = async () => {
  try {
    await mRtc.localAudioTrack.setEnabled(true);
    mRtc.isOpenMic = true;
    return true;
  } catch (error) {
    util.captureException(
      'voice-room',
      { roomUid: mRtc.roomUid, fun: 'mRtc.openMic' },
      error
    );
    throw error;
  }
};
/**
 * @description: 上麦
 * @return {*}
 */

mRtc.enterSeat = async () => {
  try {
    await mRtc.client.setClientRole('host');
    if (mRtc.isEnterSeat) {
      return;
    }
    if (mRtc.isReady) {
      await mRtc.openMic();
      await mRtc.client.publish(mRtc.localAudioTrack);
      await mRtc.closeMic();
      mRtc.isEnterSeat = true;
    } else {
      return VoiceRoomEventEmitter.on(VoiceRoomEvent.rtcReady, mRtc.enterSeat);
    }
  } catch (error) {
    util.captureException(
      'voice-room',
      { roomUid: mRtc.roomUid, fun: 'mRtc.enterSeat' },
      error
    );
    throw error;
  }
};
/**
 * @description: 下麦
 * @return {*}
 */
mRtc.leaveSeat = async () => {
  if (!mRtc.isEnterSeat) {
    return;
  }
  if (mRtc.isReady) {
    try {
      await mRtc.client.unpublish(mRtc.localAudioTrack);
    } catch (error) {
      util.captureException(
        'voice-room',
        { roomUid: mRtc.roomUid, fun: 'leaveSeat.mRtc.client.unpublish' },
        error
      );
      throw error;
    }
    try {
      await mRtc.client.setClientRole('audience');
    } catch (error) {
      util.captureException(
        'voice-room',
        { roomUid: mRtc.roomUid, fun: 'leaveSeat.mRtc.client.setClientRole' },
        error
      );
      throw error;
    }
    mRtc.isEnterSeat = false;
    mRtc.isOpenMic = false;
  } else {
    try {
      return VoiceRoomEventEmitter.on(VoiceRoomEvent.rtcReady, mRtc.enterSeat);
    } catch (error) {
      util.captureException(
        'voice-room',
        {
          roomUid: mRtc.roomUid,
          fun:
            'leaveSeat.VoiceRoomEventEmitter.on(VoiceRoomEvent.rtcReady, mRtc.enterSeat)'
        },
        error
      );
      throw error;
    }
  }
};
/**
 * @description: 获取麦克风
 * @return {microphoneId || null}
 */
mRtc.getMicrophones = async () => {
  try {
    const list = await AgoraRTC.getMicrophones(false);
    return list && list.length ? list[0].deviceId : null;
  } catch (error) {
    util.captureException(
      'voice-room',
      { roomUid: mRtc.roomUid, fun: 'mRtc.getMicrophones' },
      error
    );
    throw error;
  }
};
/**
 * @description: 测试麦克风
 * @return {microphoneId || null}
 */
mRtc.getVolumeLevel = async () => {
  try {
    const level = mRtc.localAudioTrack.getVolumeLevel();
    console.log('local stream audio level', level);
    mRtc.getMicrophones();
    return true;
  } catch (error) {
    util.captureException(
      'voice-room',
      { roomUid: mRtc.roomUid, fun: 'mRtc.getVolumeLevel' },
      error
    );
    throw error;
  }
};
/**
 * @description: 订阅远端用户
 * @return {*}
 */
mRtc.subscribeRemoteUser = async (user, mediaType) => {
  try {
    if (mediaType === 'audio') {
      await mRtc.client.subscribe(user, mediaType);
      delete mRtc.remoteUsers[user.uid];
      mRtc.remoteUsers[user.uid] = user;
      const audioTrack = user.audioTrack;
      if (audioTrack) {
        // 自动播放音频
        audioTrack.play();
      }
    }
  } catch (error) {
    util.captureException(
      'voice-room',
      { roomUid: mRtc.roomUid, fun: 'mRtc.subscribeRemoteUser' },
      error
    );
    throw error;
  }
};
mRtc.viewRemote = async () => {
  console.log(mRtc.client.remoteUsers);
};

mRtc.ready = async () => {
  try {
    mRtc.isReady = true;
    VoiceRoomEventEmitter.emit(VoiceRoomEvent.rtcReady);
    return true;
  } catch (error) {
    util.captureException(
      'voice-room',
      { roomUid: mRtc.roomUid, fun: 'mRtc.subscribeRemoteUser' },
      error
    );
    throw error;
  }
};

mRtc.enableAudioVolumeIndicator = () => {
  mRtc.client.enableAudioVolumeIndicator();
};

/**
 * @description: 声网客户端
 * @return {*}
 */
mRtc.client = AgoraRTC.createClient({
  mode: 'live',
  codec: 'vp8'
});

/**
 * @description:本地轨道对象
 * @return {*} MicrophoneAudioTrack对象
 */
// mRtc.localAudioTrack = null;

// /**
//  * @description: 监听的远程对象
//  * @return {*}
//  */
// mRtc.remoteUsers = {};
// mRtc.isReady = false;
// mRtc.isEnterSeat = false;
// 0: DEBUG。输出所有的 SDK 日志。
// 1: INFO。输出 INFO、WARNING 和 ERROR 级别的日志。
// 2: WARNING。输出 WARNING 和 ERROR 级别的日志。
// 3: ERROR。输出 ERROR 级别的日志。
// 4: NONE。不输出日志。
AgoraRTC.setLogLevel(4);
VoiceRoomEventEmitter.on(VoiceRoomEvent.enterSeat, async () => {
  await mRtc.client.setClientRole('host');
  mRtc.enterSeat();
});
VoiceRoomEventEmitter.on(VoiceRoomEvent.leaveSeat, async () => {
  mRtc.leaveSeat();
});
export default mRtc;
